import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlockedBy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.5,
			cy: 10.5,
			r: 4,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.63403 10.5H12.366",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.67624 13.0136H3.62109C2.51652 13.0136 1.62109 12.1181 1.62109 11.0136V3.51843C1.62109 2.41386 2.51652 1.51843 3.62109 1.51843H12.3789C13.4835 1.51843 14.3789 2.41386 14.3789 3.51843V5.25119",
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	]
});
export default SvgBlockedBy;
